/**
 * 제품 / 연구 모드.
 *
 * 연구 모드 = G0 측정용. 자가표기 화면·프리셋 층화·계측 배너가 켜진다.
 * 제품 모드 = 링크로 받은 사람이 그냥 플레이하는 빌드. 위 셋이 전부 꺼진다.
 *
 * 판정은 빌드 상수 하나로만 한다(RULES §1.13 APP_MODE): VITE_APP_MODE === 'research' 이면 research, 그 외 product.
 * URL(?p= · ?research=1)로는 켜지지 않는다 — URL 로 켜지던 때는 제품 빌드에서 누구나 자가표기 목록으로
 * 팩 24제 문제문 전량을 보고 다른 규칙 변종(프리셋 오답 수)으로 돌았다. G0 회차는 연구 빌드를 따로 만든다(DEPLOY.md §1).
 *
 * appModeEnv 는 import.meta.env.VITE_APP_MODE 다 — MODE('development'|'production')가 아니다.
 */
export type AppMode = 'product' | 'research';

export interface ModeFlags {
  readonly mode: AppMode;
  readonly preRunSurvey: boolean; // askPreRun 호출 여부
  readonly presetAssignment: boolean; // distractorCount 를 프리셋으로 덮어쓸지
  readonly telemetryBanner: boolean;
  readonly researchNotice: boolean;
  readonly seedInHud: boolean;
}

export function resolveMode(appModeEnv: string | undefined): AppMode {
  return appModeEnv === 'research' ? 'research' : 'product';
}

/**
 * 계측 수집처 — **연구 빌드이고 값이 실제로 있을 때만** 그 URL, 그 외 전부 null(전송 0건 · RULES §1.12 TELEMETRY_TRANSPORT).
 * `.env` 의 `VITE_TLM_URL=` 은 `''` 로 들어온다 — 그대로 넘기면 `sendBeacon('')` 이 지금 페이지 주소로 행을 보냈다.
 * 빈 값 · 공백 · `dev`(연구 개발 빌드가 일부러 끈 것 · 배너가 뜬다)는 없음이다.
 * 제품 빌드는 연구 회차가 .env 에 남긴 수집 URL 이 있어도 보내지 않는다(privacy.txt 2항 (7) · vite.config 가 그런 빌드를 거부한다).
 */
export function telemetryUrlOf(mode: AppMode, raw: string | undefined): string | null {
  if (mode !== 'research') return null;
  const v = (raw ?? '').trim();
  return v === '' || v === 'dev' ? null : v;
}

export function flagsOf(mode: AppMode): ModeFlags {
  const r = mode === 'research';
  return {
    mode,
    preRunSurvey: r,
    presetAssignment: r,
    telemetryBanner: r,
    researchNotice: r,
    // 결과 카드가 착지하기 전까지는 시드를 읽을 다른 수단이 없어 HUD 에 남긴다
    seedInHud: true,
  };
}
